
import Vue from 'vue';
export default Vue.extend<any, any, any, any>({
  /**
  - If want to change bar color, modify class <b> .bar-indicator </b>
  **/
  name: 'RemainingBar',
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set remaining label text
     */
    remainingLabel: {
      type: String,
      default: ''
    },
    /**
     * Set remaining quota
     */
    remaining: {
      type: Number,
      default: 0
    },
    /**
     * Set total quota
     */
    total: {
      type: Number,
      default: 30
    },
    /**
     * Set quota type (days, IDR)
     */
    measureType: {
      type: String,
      default: ''
    },
    /**
     * Need to determine how to write 'of' because can be multilanguage
     */
    ofLabel: {
      type: String,
      default: 'of'
    }
  },
  computed: {
    computedLoaderWidth() {
      const remainedDays = (this.remaining / this.total) * 100;
      return `width: ${remainedDays}%`;
    }
  }
});
